import { IconButton } from "../../components/IconButton";

interface Props {
  isShiftBlockAssigned: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function CancelShiftBlockIconButton(props: Props) {
  const { isShiftBlockAssigned, disabled = false, onClick } = props;

  if (!isShiftBlockAssigned) {
    return null;
  }

  return (
    <IconButton
      variant="ghost"
      iconType="ellipsis"
      size="small"
      aria-label="Cancel block"
      disabled={disabled}
      sx={{
        paddingRight: 0,
      }}
      onClick={onClick}
    />
  );
}
